import ArrayValueColumns from "./array-value-columns";
import ColumnFilters from "./column-filters";
import ColumnOptionsUpdate from "./column-options-update";
import Component from "./component";
import CSVExport from "./csv-export";
import CustomActionColumns from "./custom-action-columns";
import CustomizeColumns from "./customize-columns";
import CustomizeFilter from "./customize-filter";
import CustomizeFooter from "./customize-footer";
import CustomizeRows from "./customize-rows";
import CustomizeSearch from "./customize-search";
import CustomizeSearchRender from "./customize-search-render";
import CustomizeSorting from "./customize-sorting";
import CustomizeStyling from "./customize-styling";
import CustomizeToolbar from "./customize-toolbar";
import CustomizeSelectToolbar from "./customize-selecttoolbar";
import DataAsObjects from "./data-as-objects";
import ExpandableRows from "./expandable-rows";
import FixedHeader from "./fixed-header";
import HideColumnsPrint from "./hide-columns-print";
import OnDownload from "./on-download";
import OnTableInit from "./on-table-init";
import ResizableColumns from "./resizable-columns";
import SelectableRows from "./selectable-rows";
import ServerSideOptions from "./serverside-options";
import ServerSidePagination from "./serverside-pagination";
import Simple from "./simple";
import SimpleNoToolbar from "./simple-no-toolbar";
import TextLocalization from "./text-localization";
import Themes from "./themes";

 /**
 * Here you can add any extra examples with the Card label as the key, and the component to render as the value
 */
export default {
    'Array Value Columns': ArrayValueColumns,
    'Column Filters': ColumnFilters,
    'Column Option Update': ColumnOptionsUpdate,
    'Component': Component,
    'CSV Export': CSVExport,
    'Custom Action Columns': CustomActionColumns,
    'Custom Columns': CustomizeColumns,
    'Custom Filter': CustomizeFilter,
    'Custom Footer': CustomizeFooter,
    'Custom Rows': CustomizeRows,
    'Custom Search': CustomizeSearch,
    'Custom Search Render': CustomizeSearchRender,
    'Custom Sorting': CustomizeSorting,
    'Custom Styling': CustomizeStyling,
    'Custom Toolbar': CustomizeToolbar,
    'Custom Select Toolbar': CustomizeSelectToolbar,
    'Data As Objects': DataAsObjects,
    'Expandable Rows': ExpandableRows,
    'fixedHeader': FixedHeader,
    'Hide Columns Print': HideColumnsPrint,
    'onDownload': OnDownload,
    'onTableInit': OnTableInit,
    'resizableColumns': ResizableColumns,
    'selectableRows': SelectableRows,
    //'serverSide Options': ServerSideOptions, // this example does not do what it says it does, commenting it out
    'Server Side': ServerSidePagination,
    'Simple': Simple,
    'Simple No Toolbar': SimpleNoToolbar,
    'Text Localization': TextLocalization,
    'Themes': Themes,
};